import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import Button from "./Button";

type TypeProps = {
	count: number;
	// eslint-disable-next-line no-unused-vars
	changeOffset: (offset: number) => void;
	offset: number;
	limit: number;
};
const PaginationTwo = (props: TypeProps) => {
	const { count, changeOffset, offset, limit } = props;

	let startingItemNumber = offset + 1;
	let endingItemNumber = offset + limit > count ? count : offset + limit;

	return (
		<div className="flex items-center space-x-2">
			<p className="text-black">
				{startingItemNumber}-{endingItemNumber} of {count}
			</p>
			<Button
				onClick={() => changeOffset(offset - limit)}
				disabled={offset === 0}
				variant="transparent"
				size="small"
				className="p-1"
			>
				<BsChevronLeft className={`text-xl font-bold  ${offset === 0 ? "text-gray-400" : "text-black"}`} />
			</Button>
			<Button
				onClick={() => changeOffset(offset + limit)}
				variant="transparent"
				disabled={endingItemNumber === count}
				size="small"
				className="p-1"
			>
				<BsChevronRight
					className={`text-xl font-bold ${endingItemNumber === count ? "text-gray-400" : "text-black"}`}
				/>
			</Button>
		</div>
	);
};

export default PaginationTwo;
